/* src/app/components/doc-viewer-new/doc-viewer-context-panel/doc-node/doc-node.component.scss */
.docs-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  gap: 12px;
}
.docs-node {
  margin-right: 12px;
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .docs-node {
  --fa-primary-color: dark-doc-viewer.$dark-theme-icon-gold;
  --fa-secondary-color: #6d6c6c;
  --fa-secondary-opacity: 1 ;
}
:host-context(.dark-theme) .docs-node {
  --fa-primary-color: #E2E2E2;
  --fa-secondary-color: #6c6c6c;
  --fa-secondary-opacity: 1;
}
.selected-node {
  margin-right: 12px;
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .selected-node {
  --fa-primary-color: #FFC107;
  --fa-secondary-color:#909090;
  --fa-secondary-opacity: 1 ;
}
.child {
  padding-left: 28px;
}
.expanded {
  color: #FFC107;
}
.order-node {
  min-width: 24px;
  text-align: left;
}
/*# sourceMappingURL=doc-node.component.css.map */
